<template>
  <v-app-bar app color="primary" v-show="oauthLoginInactive || accessViaAlternative || userToken" density="comfortable">
    <router-link :to="{ name: 'Dashboard' }">
      <v-img alt="Techs" class="shrink mr-2" :src="logoPath" transition="scale-transition" height="60px" max-width="200px" contain />
    </router-link>
    <v-spacer></v-spacer>
    <div>
      <v-row justify="end" no-gutters>
        <v-col cols="auto">
          <v-menu offset-y v-if="userToken" max-width="355px" open-on-hover>
            <template v-slot:activator="{ on }">
              <v-btn dark text v-on="on" iconAfter="mdi-menu-down">
                <v-icon dark>mdi-account</v-icon>
                <span class="d-inline-block text-truncate" style="max-width: 290px">
                  {{ getUsername(userInfo) }}
                </span>
                <v-icon dark>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="text-body-1 font-weight-bold" v-show="userInfo.name">
                    <span class="d-inline-block text-truncate" style="max-width: 355px">
                      {{ getUsername(userInfo) }}
                    </span>
                  </v-list-item-title>
                  <v-list-item-title
                    :class="!userInfo.name && userInfo.businessName ? 'text-body-1 font-weight-bold' : 'text-body-2 font-weight-bold'"
                    v-show="userInfo.businessName"
                  >
                    <span class="d-inline-block text-truncate" style="max-width: 355px">
                      {{ getCompanyName(userInfo) }}
                    </span>
                  </v-list-item-title>
                  <v-list-item-title class="text-caption font-weight-light">
                    {{ $vuetify.lang.t("$vuetify.user.accountType") }} {{ getUserType(userInfo) }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-action>
                  <v-icon color="grey lighten-1">mdi-information</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-subtitle class="font-weight-bold">{{ $vuetify.lang.t("$vuetify.user.lastLogin") }}</v-list-item-subtitle>
                  <v-list-item-subtitle>{{ userInfo.lastLogin | formatDateTime }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item :to="{ name: 'MyAccount' }">
                <v-list-item-action><v-icon>mdi-account</v-icon></v-list-item-action>
                <v-list-item-title>{{ $vuetify.lang.t("$vuetify.user.myAccount") }}</v-list-item-title>
              </v-list-item>
              <v-list-item :to="{ name: 'Administrator' }" v-if="userInfo.admin">
                <v-list-item-action><v-icon>mdi-account-group</v-icon></v-list-item-action>
                <v-list-item-title>{{ $vuetify.lang.t("$vuetify.administrator.title") }}</v-list-item-title>
              </v-list-item>
              <v-list-item :to="{ name: 'Configuration' }" v-if="userInfo.admin">
                <v-list-item-action><v-icon>mdi-cog</v-icon></v-list-item-action>
                <v-list-item-title>{{ $vuetify.lang.t("$vuetify.configuration.titlePl") }}</v-list-item-title>
              </v-list-item>
              <v-list-item :to="{ name: 'Logout' }"> <!--@click="handleLogoff"></-->
                <v-list-item-action><v-icon>mdi-logout</v-icon></v-list-item-action>
                <v-list-item-title>{{ $vuetify.lang.t("$vuetify.auth.logout") }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
      <v-row justify="end" no-gutters class="mr-5">
        <v-col cols="auto" class="body-2 white--text">{{ dateNow }}</v-col>
      </v-row>
    </div>
  </v-app-bar>
</template>

<style lang="scss" scoped>
.snip-text {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  white-space: nowrap;
  width: 290px;
}

.snip-text i {
  margin: 5px;
}
</style>

<script>
import tokenService from "@/services/token";
import moment from "moment";
import parameterConfiguration from "@/api/parameterConfiguration";
import { enumUserType } from "@/enums/configurationKeys";

moment.locale("pt-br");

export default {
  name: "AppBar",
  data: () => ({
    userInfo: {},
    logoutURL: "",
    postLogoutRedirectUri: "",
  }),
  computed: {
    userToken: () => {
      return tokenService.getToken();
    },
    logoPath: () => {
      return process.env.NODE_ENV == "development" ? process.env.VUE_APP_LOGO_PATH : location.origin + "/api/portal-photos/logo.png";
    },
    dateNow: () => {
      return moment().local().format("dddd, DD [de] MMMM [de] YYYY");
    },
    oauthLoginInactive() {
      var oauthpkce = localStorage.getItem("oauthpkceParameter");
      return oauthpkce == "false";
    },
    accessViaAlternative() {
      return this.$route.name == "AlternativeLogin";
    },
  },
  filters: {
    // Update Dates from this component to user's timezone
    formatDateTime: function (value) {
      if (!value) value = new Date();
      return moment(value).local().format("DD/MM/YYYY [às] HH:mm");
    },
  },
  async created() {
    if (this.userToken) this.userInfo = tokenService.getDecodedToken().user;

    let oauthpkce = localStorage.getItem("oauthpkceParameter");
    let authenticationType = localStorage.getItem("authenticationType");

    if (oauthpkce == "true" && (authenticationType === "OAUTH" || authenticationType === "OAUTH_PKCE")) {
      await parameterConfiguration.getOauthpkceLogoutURL().then((response) => {
        this.logoutURL = response;
      });

      await parameterConfiguration.getOauthpkcePostLogoutRedirectURL().then((response) => {
        this.postLogoutRedirectUri = response;
      });
    }

    if (oauthpkce == "true" && authenticationType === "GOV_BR") {
      await parameterConfiguration.getGovBrOauthpkceLogoutURL().then((response) => {
        this.logoutURL = response;
      });

      await parameterConfiguration.getGovBrOauthpkcePostLogoutRedirectURL().then((response) => {
        this.postLogoutRedirectUri = response;
      });
    }
  },
  methods: {
    handleLogoff() {
      // Remove Token
      tokenService.removeToken();

      let oauthpkce = localStorage.getItem("oauthpkceParameter");
      if (oauthpkce == "true") {
        let idtoken = localStorage.getItem("id_token");
        window.location.href = `${this.logoutURL}?id_token_hint=${idtoken}&post_logout_redirect_uri=${this.postLogoutRedirectUri}`;
      } else {
        // Redirect to Login
        this.$router.push({ name: "Login" });
      }
    },
    getUsername(user) {
      if (user === null || user === undefined) {
        return "";
      }

      if (user.name) {
        return user.name;
      }

      if (user.businessName) {
        return user.businessName;
      }
    },
    getUserType(user) {
      if (user === null || user === undefined) {
        return "";
      }

      if (user.type) {
        return user.type;
      }

      return enumUserType.PF;
    },
    getCompanyName(user) {
      if (user === null || user === undefined) {
        return "";
      }

      if (user.businessName) {
        return user.businessName;
      }

      return "";
    },
  },
};
</script>
